export default __webpack_public_path__ + "static/media/optosfill.61f99ee5.svg";